import { EventType } from "./Events";
export default function createEventPublisher(subscriber, sessionId) {
    return {
        open: function () {
            subscriber(EventType.OPEN, { sessionId: sessionId });
        },
        close: function () {
            subscriber(EventType.CLOSE, { sessionId: sessionId });
        },
        authComplete: function () {
            subscriber(EventType.AUTH_COMPLETE, { sessionId: sessionId });
        },
        searchIssuer: function (issuerSearchQuery) {
            subscriber(EventType.SEARCH_ISSUER, { sessionId: sessionId, issuerSearchQuery: issuerSearchQuery });
        },
        selectIssuer: function (issuerId, _a) {
            var _b = _a === void 0 ? {} : _a, linkingSupported = _b.linkingSupported;
            subscriber(EventType.SELECT_ISSUER, {
                sessionId: sessionId,
                issuerId: issuerId,
                linking_supported: linkingSupported,
            });
        },
        submitCredentials: function () {
            subscriber(EventType.SUBMIT_CREDENTIALS, { sessionId: sessionId });
        },
        submitMFA: function () {
            subscriber(EventType.SUBMIT_MFA, { sessionId: sessionId });
        },
        transitionView: function (viewName) {
            subscriber(EventType.TRANSITION_VIEW, { sessionId: sessionId, view_name: viewName });
        },
        loadOffers: function (impressionId, quotes, ads, lifeQuotes, _a) {
            var _b = _a === void 0 ? {} : _a, accountHasData = _b.accountHasData, accountLinked = _b.accountLinked;
            subscriber(EventType.LOAD_OFFERS, {
                sessionId: sessionId,
                impressionId: impressionId,
                quotes: quotes,
                ads: ads,
                lifeQuotes: lifeQuotes,
                accountLinked: accountLinked,
                accountHasData: accountHasData,
            });
        },
        clickOffer: function (offer, impressionId) {
            subscriber(EventType.CLICK_OFFER, { sessionId: sessionId, offer: offer, impressionId: impressionId });
        },
        provideConsent: function () {
            subscriber(EventType.PROVIDE_CONSENT, { sessionId: sessionId });
        },
        applicationComplete: function (accountInfo, policies) {
            subscriber(EventType.APPLICATION_COMPLETE, {
                sessionId: sessionId,
                accountInfo: accountInfo,
                policies: policies,
            });
        },
        identifyPartner: function (partnerId, partnerName) {
            subscriber(EventType.IDENTIFY_PARTNER, {
                sessionId: sessionId,
                partnerId: partnerId,
                partnerName: partnerName,
            });
        },
    };
}
